import React from "react"
import { LinkModalContextProvider } from "./custom-components"

import {
  TypeBlockQuoteSkeleton,
  TypeContainerSkeleton,
  TypeContentBlockSkeleton,
  TypeContentBlockWithIconSkeleton,
  TypeTwoColumnBulletListSkeleton,
  TypeTwoColumnLayoutSkeleton,
  TypeModalSkeleton,
  TypeUnorderedListSkeleton,
  TypeAccordionSkeleton,
  TypeBannerImageSkeleton
} from "#/types/contentful"
import { Entry } from "contentful"
import { CarrotMatchContextProvider } from "#/components/carrot-match-fertility-clinic-precision-matching/context/CarrotMatchContext"

import { RecursiveContentfulContentRenderer, RecursiveContentfulContentRendererProps } from "./legacy/content-renderer"
import { useFlags } from "launchdarkly-react-client-sdk"
import { ContentRendererForContentfulEntries } from "#/services/contentful/renderer"
import {
  ContentfulMarkdownOverrideContext,
  ContentfulMarkdownOverrides
} from "#/services/contentful/contentful-markdown-renderer"
export type ContentfulContentEntry = Entry<
  | TypeAccordionSkeleton
  | TypeBlockQuoteSkeleton
  | TypeContainerSkeleton
  | TypeContentBlockSkeleton
  | TypeContentBlockWithIconSkeleton
  | TypeTwoColumnBulletListSkeleton
  | TypeTwoColumnLayoutSkeleton
  | TypeUnorderedListSkeleton
  | TypeModalSkeleton
  | TypeBannerImageSkeleton,
  "WITHOUT_UNRESOLVABLE_LINKS",
  string
>

export interface ContentfulContentRendererProps
  extends RecursiveContentfulContentRendererProps,
    ContentfulMarkdownOverrides {}

export function ContentfulContentRenderer({ contents, asList, ...markdownProps }: ContentfulContentRendererProps) {
  const { experimentalContentfulRenderer } = useFlags()
  if (experimentalContentfulRenderer) {
    return <ContentRendererForContentfulEntries contentfulEntries={contents} asList={asList} {...markdownProps} />
  }
  return (
    <ContentfulMarkdownOverrideContext.Provider value={markdownProps || {}}>
      <LinkModalContextProvider>
        <CarrotMatchContextProvider>
          <RecursiveContentfulContentRenderer {...{ contents, asList }} />
        </CarrotMatchContextProvider>
      </LinkModalContextProvider>
    </ContentfulMarkdownOverrideContext.Provider>
  )
}
